import { appVersion } from '@/common/device-info';
import { useQuery } from '@/hooks/useQuery';
import { versionCompare } from '@kibt/web-utils/version';
import React from 'react';
import { Platform, StyleProp, ViewStyle } from 'react-native';
import { NativeFixedView as KSNativeFixedView } from '@kibt/meta-ui-krn/lib/components/FiexedView/NativeFixedView';

/**
 * 固定实现方案：
 * 1. Android < 10.3.40 采用 style={positoin: fixed} 进行固底，同时position: fixed不需要配合bottom来实现固底，半屏容器高度是实际就是半屏的高度
 * 2. Android >= 10.3.40 采用 FixedView 进行固底， 存在两个Bug
 *     2.1一个bug是 全屏容器打开的半屏容器，无法实现固底，所以需要使用style={positoin: fixed} 进行固底，同时position: fixed需要配合bottom来实现固底，半屏容器高度是实际是全屏高度
 *     2.2一个bug是 部分机型固底下面有刘海屏底部缝隙
 * 3. Android >= 10.4.20 解决 全屏容器打开的半屏容器，无法实现固底 的bug，同时解决
 *
 * 4. iOS < 10.3.40 采用 吸底Tag 进行固底
 * 5. iOS >= 10.3.40 采用 FixedView 进行固底
 */
const versionSupport = versionCompare(appVersion, '10.3.40') >= 0;
export const isFixedViewSupport = versionSupport && Platform.OS !== 'web';
console.log('isSupportFixedView:::', isFixedViewSupport);

export const NativeFixedView: React.FC<{
    // 距离顶部距离
    marginTop?: number;
    // 距离底部距离
    marginBottom?: number;
    // ios半屏容器需要传
    openSlideFullScreen?: boolean;
    style?: StyleProp<ViewStyle>;
    className?: string;
}> = isFixedViewSupport ? KSNativeFixedView : null;

function WrapFixedView(
    props: React.PropsWithChildren<{
        // 距离顶部距离
        top?: number;
        // 距离底部距离
        bottom?: number;
        fallback?: () => React.ReactNode;
    }>
) {
    const openSlideFullScreen = useQuery('openSlideFullScreen') as string;

    return isFixedViewSupport ? (
        <NativeFixedView marginTop={props.top} marginBottom={props.bottom} openSlideFullScreen={+openSlideFullScreen === 1}>
            {props.children}
        </NativeFixedView>
    ) : (
        <>{props.fallback ? props.fallback() : props.children}</>
    );
}

export const FixedView = React.memo(WrapFixedView);
// export const FixedView = shouldFallbackFixedView ? React.memo(Fallback) : React.memo(WrapFixedView);
